"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const ss = typeof sessionStorage === 'object' ? {
  set(key, value) {
    try {
      value = JSON.stringify(value);
    } catch (err) {
      console.warn(err);
    }
    try {
      sessionStorage.setItem(key, value);
    } catch (err) {
      console.warn(err);
    }
  },
  get(key) {
    let value;
    try {
      value = sessionStorage.getItem(key);
    } catch (err) {
      console.warn(err);
    }
    try {
      value = JSON.parse(value);
    } catch (err) {
      console.warn(err);
    }
    return value;
  },
  remove(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (err) {
      console.warn(err);
    }
  }
} : {
  set() {},
  get() {},
  remove() {}
};
var _default = exports.default = ss;